import { render, staticRenderFns } from "./ChatterModalTable.vue?vue&type=template&id=68a02e76"
import script from "./ChatterModalTable.vue?vue&type=script&lang=js"
export * from "./ChatterModalTable.vue?vue&type=script&lang=js"
import style0 from "./ChatterModalTable.vue?vue&type=style&index=0&id=68a02e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports